import { SamlApi } from '@/services/apis/saml-api';
import { httpClient } from '@/services/instance/api/httpClient';

export const samlApi = new SamlApi({
    httpClient,
});
